import { DynamicLink, PortalPaymentAccessServices } from '@nimbus/portal-service';
import { DeepPartial } from './utils';

/**
 *
 * @export
 * @interface PortalServiceAccessDeniedErrorResponseDto
 */
export interface PortalServiceAccessDeniedErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceAccessDeniedErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceAccessDeniedErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceAccessDeniedErrorResponseDto
   */
  reason?: string;
}
/**
 *
 * @export
 * @interface PortalServiceAddNoteToPortalDataDto
 */
export interface PortalServiceAddNoteToPortalDataDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceAddNoteToPortalDataDto
   */
  noteGlobalId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceAddNoteToPortalDataDto
   */
  title: string;
  /**
   *
   * @type {boolean}
   * @memberof PortalServiceAddNoteToPortalDataDto
   */
  published: boolean;
  /**
   *
   * @type {number}
   * @memberof PortalServiceAddNoteToPortalDataDto
   */
  sectionId?: number;
}
/**
 *
 * @export
 * @interface PortalServiceApiCreatePortal200ResponseDto
 */
export interface PortalServiceApiCreatePortal200ResponseDto {
  /**
   *
   * @type {PortalServicePortalDto}
   * @memberof PortalServiceApiCreatePortal200ResponseDto
   */
  portal?: PortalServicePortalDto;
  /**
   *
   * @type {PortalServicePortalMemberDto}
   * @memberof PortalServiceApiCreatePortal200ResponseDto
   */
  member?: PortalServicePortalMemberDto;
}
/**
 *
 * @export
 * @interface PortalServiceApiGetPagesSearch200ResponseDto
 */
export interface PortalServiceApiGetPagesSearch200ResponseDto {
  /**
   *
   * @type {Array<PortalServiceApiGetPagesSearch200ResponseItemsInnerDto>}
   * @memberof PortalServiceApiGetPagesSearch200ResponseDto
   */
  items: Array<PortalServiceApiGetPagesSearch200ResponseItemsInnerDto>;
  /**
   *
   * @type {number}
   * @memberof PortalServiceApiGetPagesSearch200ResponseDto
   */
  total: number;
}
/**
 *
 * @export
 * @interface PortalServiceApiGetPagesSearch200ResponseItemsInnerDto
 */
export interface PortalServiceApiGetPagesSearch200ResponseItemsInnerDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceApiGetPagesSearch200ResponseItemsInnerDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceApiGetPagesSearch200ResponseItemsInnerDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceApiGetPagesSearch200ResponseItemsInnerDto
   */
  url: string;
  /**
   *
   * @type {PortalServiceApiGetPagesSearch200ResponseItemsInnerHighlightsDto}
   * @memberof PortalServiceApiGetPagesSearch200ResponseItemsInnerDto
   */
  highlights: PortalServiceApiGetPagesSearch200ResponseItemsInnerHighlightsDto;
}
/**
 *
 * @export
 * @interface PortalServiceApiGetPagesSearch200ResponseItemsInnerHighlightsDto
 */
export interface PortalServiceApiGetPagesSearch200ResponseItemsInnerHighlightsDto {
  /**
   *
   * @type {Array<string>}
   * @memberof PortalServiceApiGetPagesSearch200ResponseItemsInnerHighlightsDto
   */
  title?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof PortalServiceApiGetPagesSearch200ResponseItemsInnerHighlightsDto
   */
  text?: Array<string>;
}
/**
 *
 * @export
 * @interface PortalServiceApiPostImportRequestDto
 */
export interface PortalServiceApiPostImportRequestDto {
  /**
   *
   * @type {boolean}
   * @memberof PortalServiceApiPostImportRequestDto
   */
  all?: boolean;
  /**
   *
   * @type {string}
   * @memberof PortalServiceApiPostImportRequestDto
   */
  workspaceId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PortalServiceApiPostImportRequestDto
   */
  portalIds?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof PortalServiceApiPostImportRequestDto
   */
  force?: boolean;
}
/**
 *
 * @export
 * @interface PortalServiceCreatePortalDataDto
 */
export interface PortalServiceCreatePortalDataDto {
  /**
   *
   * @type {boolean}
   * @memberof PortalServiceCreatePortalDataDto
   */
  setup: boolean;
  /**
   *
   * @type {string}
   * @memberof PortalServiceCreatePortalDataDto
   */
  domain?: string;
}
/**
 *
 * @export
 * @interface PortalServiceCreatePortalDataTestDto
 */
export interface PortalServiceCreatePortalDataTestDto {
  /**
   *
   * @type {boolean}
   * @memberof PortalServiceCreatePortalDataTestDto
   */
  setup: boolean;
  /**
   *
   * @type {number}
   * @memberof PortalServiceCreatePortalDataTestDto
   */
  interval: number;
  /**
   *
   * @type {number}
   * @memberof PortalServiceCreatePortalDataTestDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface PortalServiceDnsRecordDto
 */
export interface PortalServiceDnsRecordDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceDnsRecordDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceDnsRecordDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceDnsRecordDto
   */
  status?: PortalServiceDnsRecordDtoStatusEnum;
}

export const PortalServiceDnsRecordDtoStatusEnum = {
  NA: 'n/a',
  Waiting: 'waiting',
  Success: 'success',
  Failed: 'failed',
} as const;

export type PortalServiceDnsRecordDtoStatusEnum =
  (typeof PortalServiceDnsRecordDtoStatusEnum)[keyof typeof PortalServiceDnsRecordDtoStatusEnum];

/**
 *
 * @export
 * @interface PortalServiceDomainExistsDto
 */
export interface PortalServiceDomainExistsDto {
  /**
   *
   * @type {boolean}
   * @memberof PortalServiceDomainExistsDto
   */
  exists: boolean;
}
/**
 *
 * @export
 * @interface PortalServiceErrorResponseDto
 */
export interface PortalServiceErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface PortalServiceInternalErrorResponseDto
 */
export interface PortalServiceInternalErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceInternalErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceInternalErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface PortalServiceNotFoundErrorResponseDto
 */
export interface PortalServiceNotFoundErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceNotFoundErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceNotFoundErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface PortalServicePortalDto
 */
export interface PortalServicePortalDto {
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  globalId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  workspaceId: string;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  domain: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  status: PortalServicePortalDtoStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  updatedAt: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  port: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  setupCode?: string;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  retry?: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  distributionId?: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  cnameValue?: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalDto
   */
  cnameStatus?: PortalServicePortalDtoCnameStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalDto
   */
  version: number;
}

export const PortalServicePortalDtoStatusEnum = {
  Pending: 'pending',
  Setting: 'setting',
  Validation: 'validation',
  Ready: 'ready',
  Disabled: 'disabled',
  Failed: 'failed',
} as const;

export type PortalServicePortalDtoStatusEnum =
  (typeof PortalServicePortalDtoStatusEnum)[keyof typeof PortalServicePortalDtoStatusEnum];
export const PortalServicePortalDtoCnameStatusEnum = {
  NA: 'n/a',
  Waiting: 'waiting',
  Success: 'success',
  Failed: 'failed',
} as const;

export type PortalServicePortalDtoCnameStatusEnum =
  (typeof PortalServicePortalDtoCnameStatusEnum)[keyof typeof PortalServicePortalDtoCnameStatusEnum];

/**
 *
 * @export
 * @interface PortalServicePortalExtendedAllOfDto
 */
export interface PortalServicePortalExtendedAllOfDto {
  /**
   *
   * @type {Array<PortalServiceDnsRecordDto>}
   * @memberof PortalServicePortalExtendedAllOfDto
   */
  dnsRecords?: Array<PortalServiceDnsRecordDto>;
}
/**
 *
 * @export
 * @interface PortalServicePortalExtendedDto
 */
export interface PortalServicePortalExtendedDto {
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalExtendedDto
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  globalId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  workspaceId: string;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalExtendedDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  domain: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  status: PortalServicePortalExtendedDtoStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalExtendedDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalExtendedDto
   */
  updatedAt: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalExtendedDto
   */
  port: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  setupCode?: string;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalExtendedDto
   */
  retry?: number;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  distributionId?: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  cnameValue?: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalExtendedDto
   */
  cnameStatus?: PortalServicePortalExtendedDtoCnameStatusEnum;
  /**
   *
   * @type {Array<PortalServiceDnsRecordDto>}
   * @memberof PortalServicePortalExtendedDto
   */
  dnsRecords?: Array<PortalServiceDnsRecordDto>;
}

export const PortalServicePortalExtendedDtoStatusEnum = {
  Pending: 'pending',
  Setting: 'setting',
  Validation: 'validation',
  ChatsReady: 'chatsReady',
  Ready: 'ready',
  Disabled: 'disabled',
  Failed: 'failed',
} as const;

export type PortalServicePortalExtendedDtoStatusEnum =
  (typeof PortalServicePortalExtendedDtoStatusEnum)[keyof typeof PortalServicePortalExtendedDtoStatusEnum];
export const PortalServicePortalExtendedDtoCnameStatusEnum = {
  NA: 'n/a',
  Waiting: 'waiting',
  Success: 'success',
  Failed: 'failed',
} as const;

export type PortalServicePortalExtendedDtoCnameStatusEnum =
  (typeof PortalServicePortalExtendedDtoCnameStatusEnum)[keyof typeof PortalServicePortalExtendedDtoCnameStatusEnum];

/**
 *
 * @export
 * @interface PortalServicePortalMemberDto
 */
export interface PortalServicePortalMemberDto {
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalMemberDto
   */
  portalId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalMemberDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalMemberDto
   */
  role: PortalServicePortalMemberDtoRoleEnum;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalMemberDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalMemberDto
   */
  password: string;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalMemberDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalMemberDto
   */
  updatedAt: number;
}

export const PortalServicePortalMemberDtoRoleEnum = {
  Admin: 'admin',
  Member: 'member',
} as const;

export type PortalServicePortalMemberDtoRoleEnum =
  (typeof PortalServicePortalMemberDtoRoleEnum)[keyof typeof PortalServicePortalMemberDtoRoleEnum];

/**
 *
 * @export
 * @interface PortalServicePortalsUsageDto
 */
export interface PortalServicePortalsUsageDto {
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalsUsageDto
   */
  active: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalsUsageDto
   */
  free: number;
  /**
   *
   * @type {number}
   * @memberof PortalServicePortalsUsageDto
   */
  limit: number;
  /**
   *
   * @type {boolean}
   * @memberof PortalServicePortalsUsageDto
   */
  addonsAllowed: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PortalServicePortalsUsageDto
   */
  canManagePortals: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PortalServicePortalsUsageDto
   */
  canPurchaseAddons: boolean;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalsUsageDto
   */
  subscriptionId?: string;
  /**
   *
   * @type {string}
   * @memberof PortalServicePortalsUsageDto
   */
  subscriptionPlanTerm: PortalServicePortalsUsageDtoSubscriptionPlanTermEnum;
  /**
   *
   * @type {boolean}
   * @memberof PortalServicePortalsUsageDto
   */
  ltdPaymentPage: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PortalServicePortalsUsageDto
   */
  domains: Array<string>;
}

export const PortalServicePortalsUsageDtoSubscriptionPlanTermEnum = {
  No: 'no',
  Yearly: 'yearly',
  Monthly: 'monthly',
} as const;

export type PortalServicePortalsUsageDtoSubscriptionPlanTermEnum =
  (typeof PortalServicePortalsUsageDtoSubscriptionPlanTermEnum)[keyof typeof PortalServicePortalsUsageDtoSubscriptionPlanTermEnum];

/**
 *
 * @export
 * @interface PortalServiceUpdatePortalDataDto
 */
export interface PortalServiceUpdatePortalDataDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceUpdatePortalDataDto
   */
  status?: PortalServiceUpdatePortalDataDtoStatusEnum;
}

export const PortalServiceUpdatePortalDataDtoStatusEnum = {
  Ready: 'ready',
  Disabled: 'disabled',
} as const;

export type PortalServiceUpdatePortalDataDtoStatusEnum =
  (typeof PortalServiceUpdatePortalDataDtoStatusEnum)[keyof typeof PortalServiceUpdatePortalDataDtoStatusEnum];

/**
 *
 * @export
 * @interface PortalServiceValidationErrorResponseDto
 */
export interface PortalServiceValidationErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof PortalServiceValidationErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceValidationErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PortalServiceValidationErrorResponseDto
   */
  field: string;
}

/**
 * Blocks
 */
export type PortalServiceBlockDtoType =
  | 'embed'
  | 'task-list'
  | 'chat'
  | 'note'
  | 'content'
  | 'info'
  | 'docs'
  | 'help'
  | 'request'
  | 'meetings'
  | 'links'
  | 'files-dashboard'
  | 'files-recent'
  | 'files-bucket'
  | 'flexible'
  | 'tasks-dashboard'
  | 'chats-dashboard';

export type PortalServiceBlockDtoEmbedType =
  | 'custom'
  | 'youtube'
  | 'google-drive'
  | 'ms-doc'
  | 'calendly'
  | 'airtable'
  | 'loom'
  | 'data-studio'
  | 'figma'
  | 'miro'
  | 'hubspot'
  | 'unknown';

export interface PortalServiceFilesDtoQuery {
  conjunction: 'or' | 'and';
  bucketIds?: string[];
  targets?: string[];
  targetIds?: string[];
  userIds?: number[];
  types?: string[];
}

export interface PortalServiceTasksDtoQuery {
  conjunction: 'or' | 'and';
  userIds?: number[];
}

export interface PortalServiceFilesDtoSort {
  field: 'createdAt' | 'filename' | 'size';
  order: 'asc' | 'desc';
}

export interface PortalServiceTasksDtoSort {
  field: 'createdAt';
  order: 'asc' | 'desc';
}

export interface PortalServiceFilesDtoLimit {
  size: number;
  from: number;
}

export interface PortalServiceTasksDtoLimit {
  size: number;
  from: number;
}

export interface PortalServiceFilesDtoSearch {
  query: PortalServiceFilesDtoQuery;
  sort: PortalServiceFilesDtoSort;
  limit: PortalServiceFilesDtoLimit;
}

export interface PortalServiceTasksDtoSearch {
  query: PortalServiceTasksDtoQuery;
  sort: PortalServiceTasksDtoSort;
  limit: PortalServiceTasksDtoLimit;
}

export type PortalServiceBlockDtoPlace =
  | 'global_header'
  | 'global_body'
  | 'global_footer'
  | 'page_header'
  | 'page_body_top'
  | 'page_body'
  | 'page_body_bottom'
  | 'page_footer';

export type PortalServiceBlockDtoMedia = 'base' | 'md' | 'lg';

export interface PortalServiceBlockDtoWrapper {
  type: string;
}

export type PortalServiceBlockActionDtoType = 'editContentButton';

export interface PortalServiceBlockActionDtoBase {
  type: PortalServiceBlockActionDtoType;
  enabled: boolean;
}

export interface PortalServiceBlockActionDtoEditContentButton extends PortalServiceBlockActionDtoBase {
  type: 'editContentButton';
  title: string;
}

export type PortalServiceBlockActionDto = PortalServiceBlockActionDtoEditContentButton;

export interface PortalBlockDataItemDto {
  type: string;
  dataSet: {
    values: object;
    meta: {
      userId: number;
      createdAt: number;
    };
  }[];
}

export interface PortalServiceBaseBlockDto {
  id: string;
  type: PortalServiceBlockDtoType;
  title: string;
  index: number;
  place: PortalServiceBlockDtoPlace;
  colspan: number;
  rowspan: number;
  actions: PortalServiceBlockActionDto[];
  mediaSizes: PortalServiceBlockDtoMedia[];
  wrapper: PortalServiceBlockDtoWrapper;
  enabled: boolean;
  removable: boolean;
  pageId: string;
  data: PortalBlockDataItemDto[];
}

export interface PortalServiceEmbedBlockDto extends PortalServiceBaseBlockDto {
  type: 'embed';
  embedType: PortalServiceBlockDtoEmbedType;
  content: string;
  contentUrl: string;
}

export interface PortalServiceNoteBlockDto extends PortalServiceBaseBlockDto {
  type: 'note';
  orgId: string;
  workspaceId: string;
  noteId: string;
  shareId: number;
  shareSecurityKey: string;
}

export interface PortalServiceContentBlockDto extends Omit<PortalServiceNoteBlockDto, 'type'> {
  type: 'content';
  title: string;
  text: string;
}

export interface PortalServiceInfoBlockDto extends PortalServiceBaseBlockDto {
  type: 'info';
  image: string;
  link: string;
  openInNewTab: boolean;
}

export interface PortalServiceDocsBlockDto extends Omit<PortalServiceInfoBlockDto, 'type'> {
  type: 'docs';
}

export interface PortalServiceRequestBlockDto extends Omit<PortalServiceInfoBlockDto, 'type'> {
  type: 'request';
}

export interface PortalServiceHelpBlockDto extends Omit<PortalServiceInfoBlockDto, 'type'> {
  type: 'help';
}

export interface PortalServiceMeetingsBlockDto extends Omit<PortalServiceInfoBlockDto, 'type'> {
  type: 'meetings';
}

export interface PortalServiceLinksBlockDto extends Omit<PortalServiceInfoBlockDto, 'type'> {
  type: 'links';
}

export interface PortalServiceTaskBlockDto extends PortalServiceBaseBlockDto {
  type: 'task-list';
  orgId: string;
  workspaceId: string;
  taskListIds: string[];
  readonlyEnabled: boolean;
}

export interface PortalServiceChatBlockDto extends PortalServiceBaseBlockDto {
  type: 'chat';
  orgId: string;
  workspaceId: string;
  readonlyEnabled: boolean;
}

export interface PortalServiceFilesDashboardBlockDto
  extends PortalServiceBaseBlockDto,
    Pick<PortalServiceFilesDtoSearch, 'sort'>,
    Partial<Pick<PortalServiceFilesDtoSearch, 'query' | 'limit'>> {
  type: 'files-dashboard';
}

export interface PortalServiceTasksDashboardBlockDto extends PortalServiceBaseBlockDto {
  type: 'tasks-dashboard';
}

export interface PortalServiceChatsDashboardBlockDto extends PortalServiceBaseBlockDto {
  type: 'chats-dashboard';
}

export interface PortalServiceFilesRecentBlockDto
  extends PortalServiceBaseBlockDto,
    Pick<PortalServiceFilesDtoSearch, 'sort' | 'limit'>,
    Partial<Pick<PortalServiceFilesDtoSearch, 'query'>> {
  type: 'files-recent';
  dynamicLink?: DynamicLink[];
}
export interface PortalServiceFilesBucketBlockDto
  extends PortalServiceBaseBlockDto,
    Partial<Pick<PortalServiceFilesDtoSearch, 'sort' | 'limit'>> {
  type: 'files-bucket';
  description: string;
  query: Required<Pick<PortalServiceFilesDtoSearch['query'], 'bucketIds'>> &
    Omit<PortalServiceFilesDtoSearch['query'], 'bucketIds'>;
}
interface PortalServiceFlexibleBlockBrickDto {
  brickType: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;
}

export interface PortalServiceFlexibleBlockDto extends PortalServiceBaseBlockDto {
  type: 'flexible';
  template: { type: string; view: string };
  bricks: PortalServiceFlexibleBlockBrickDto[];
  className?: string[];
}
export type PortalServiceBlockDto =
  | PortalServiceInfoBlockDto
  | PortalServiceEmbedBlockDto
  | PortalServiceNoteBlockDto
  | PortalServiceContentBlockDto
  | PortalServiceDocsBlockDto
  | PortalServiceRequestBlockDto
  | PortalServiceHelpBlockDto
  | PortalServiceMeetingsBlockDto
  | PortalServiceTaskBlockDto
  | PortalServiceChatBlockDto
  | PortalServiceLinksBlockDto
  | PortalServiceFilesDashboardBlockDto
  | PortalServiceFilesRecentBlockDto
  | PortalServiceFilesBucketBlockDto
  | PortalServiceFlexibleBlockDto
  | PortalServiceTasksDashboardBlockDto
  | PortalServiceChatsDashboardBlockDto;

/**
 * Permissions
 */
export interface PortalServicePermissionsDto {
  allowAll: boolean;
  rejectAll: boolean;
  allowUserIds: number[];
  rejectUserIds: number[];
}

/**
 * Menu items
 */
export type PortalServiceMenuItemDtoPositionType = 'top' | 'sidebar' | 'footer';
export type PortalServiceMenuItemDtoType =
  | 'home'
  | 'link'
  | 'notesFolder'
  | 'note'
  | 'portalSection'
  | 'portalProcess'
  | 'portalPage'
  | 'unknown'
  | 'allPages'
  | 'tasks'
  | 'tags'
  | 'tag'
  | 'aiAgents'
  | 'chat'
  | 'folders'
  | 'portalFilesDashboard'
  | 'filesManager'
  | 'portalTasksDashboard'
  | 'portalChatsDashboard';

export interface PortalServiceBaseMenuItemDto {
  id: string;
  positionType: PortalServiceMenuItemDtoPositionType;
  type: PortalServiceMenuItemDtoType;
  parentId: string;
  isOrigin?: boolean | null;
  originGlobalId?: string | null;
  index: number;
  visible: boolean;
  url: string;
  slug: string;
  openInNewTab: boolean;
  hasChildren: boolean;
  updatedAt?: number;
  children?: PortalServiceMenuItemDto[];
  icon?: string;
  name?: string;
  pageId?: string;
  permissions?: PortalServicePermissionsDto;
}

export interface PortalServiceHomeMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'home';
}

export interface PortalServiceLinkMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'link';
}

export interface PortalServiceNotesFolderMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'notesFolder';
  targetId: string;
}

export interface PortalServiceNoteMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'note';
  targetId: string;
}

export interface PortalServicePortalSectionMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'portalSection';
  name: string;
}

export interface PortalServicePortalProcessMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'portalProcess';
  name: string;
}

export interface PortalServicePortalPageMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'portalPage';
  name: string;
  targetId?: string;
}

export interface PortalServiceUnknownMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'unknown';
  originalAttributes: unknown;
}

export interface PortalServiceAllPagesMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'allPages';
}

export interface PortalServiceFilesMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'filesManager';
}

export interface PortalServiceTasksMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'tasks';
}

export interface PortalServiceTagsMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'tags';
}

export interface PortalServiceAIAgentsMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'aiAgents';
}

export interface PortalServiceTagMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'tag';
}

export interface PortalServiceChatMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'chat';
}

export interface PortalServiceFoldersMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'folders';
}

export interface PortalServicePortalFilesDashboardMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'portalFilesDashboard';
  name: string;
}

export interface PortalServicePortalTasksDashboardMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'portalTasksDashboard';
  name: string;
}

export interface PortalServicePortalChatsDashboardMenuItemDto extends PortalServiceBaseMenuItemDto {
  type: 'portalChatsDashboard';
  name: string;
}

export type PortalServiceMenuItemDto =
  | PortalServiceHomeMenuItemDto
  | PortalServiceLinkMenuItemDto
  | PortalServiceNotesFolderMenuItemDto
  | PortalServiceNoteMenuItemDto
  | PortalServicePortalSectionMenuItemDto
  | PortalServicePortalProcessMenuItemDto
  | PortalServicePortalPageMenuItemDto
  | PortalServiceUnknownMenuItemDto
  | PortalServiceAllPagesMenuItemDto
  | PortalServiceTasksMenuItemDto
  | PortalServiceTagsMenuItemDto
  | PortalServiceTagMenuItemDto
  | PortalServiceChatMenuItemDto
  | PortalServiceAIAgentsMenuItemDto
  | PortalServiceFoldersMenuItemDto
  | PortalServiceFilesMenuItemDto
  | PortalServicePortalFilesDashboardMenuItemDto
  | PortalServicePortalTasksDashboardMenuItemDto
  | PortalServicePortalChatsDashboardMenuItemDto;

/**
 * Theme
 */
export type PortalServiceThemeDtoPaletteBg = string;
export type PortalServiceThemeDtoPaletteText = string;
export type PortalServiceThemeDtoPaletteBorder = string;
export type PortalServiceThemeDtoPaletteShadow = string;
export type PortalServiceThemeDtoBorderType =
  | 'outline_footer'
  | 'outline_surface'
  | 'outline_surface_hover'
  | 'outline_surface_variant'
  | 'outline_surface_inner'
  | 'outline_surface_inner_variant'
  | 'soutline_urface_variant_hover'
  | 'outline_surface_inner_bg_hover'
  | 'primary';
export type PortalServiceThemeDtoShadowType = 'shadow_main' | 'shadow_hover' | 'shadow_search';
export type PortalServiceThemeDtoBgType =
  | 'bg_greeting_1'
  | 'bg_greeting_2'
  | 'bg_body'
  | 'bg_header'
  | 'bg_footer'
  | 'bg_primary'
  | 'bg_secondary'
  | 'bg_surface'
  | 'bg_surface_text'
  | 'bg_tooltip'
  | 'bg_surface_variant'
  | 'bg_surface_inner'
  | 'bg_surface_inner_variant'
  | 'bg_header_hover'
  | 'bg_body_hover'
  | 'bg_surface_variant_hover'
  | 'bg_surface_inner_hover'
  | 'bg_primary_hover'
  | 'bg_secondary_hover'
  | 'bg_footer_line'
  | 'bg_fill_surface'
  | 'footer_links'
  | 'footer_links_hover'
  | 'header_links';
export type PortalServiceThemeDtoTextType =
  | 'text_surface'
  | 'text_surface_2'
  | 'text_surface_3'
  | 'text_surface_variant'
  | 'text_surface_variant_2'
  | 'text_surface_inner'
  | 'text_surface_inner_2'
  | 'text_surface_inner_variant'
  | 'text_surface_inner_variant_2'
  | 'text_secondary'
  | 'text_header'
  | 'text_body'
  | 'text_footer'
  | 'text_footer_2'
  | 'text_footer_hover'
  | 'text_tooltip'
  | 'text_primary'
  | 'text_primary_hover';
export type PortalServiceThemeDtoColorSchemas =
  | 'light_purple'
  | 'light_orange'
  | 'light_blue'
  | 'space_gray'
  | 'dark_night'
  | 'wedding_1'
  | 'wedding_2';
export type PortalServiceThemeDtoSearchPosition = 'none' | 'sidebar' | 'header_icon' | 'header_hero';
export type PortalServiceThemeDtoHeaderType = string;
export type PortalServiceThemeDtoHeroType = string;
export type PortalServiceThemeDtoHeaderWidth = 'wide' | 'short';
export type PortalServiceThemeDtoSidebarType = 'standard' | 'multi';
export type PortalServiceThemeDtoFooterType = 'high' | 'low';
export type PortalServiceThemeDtoFooterWidth = 'wide' | 'short';
export type PortalServiceThemeDtoRoundedStyle =
  | 'rounded-none'
  | 'rounded'
  | 'rounded-sm'
  | 'rounded-md'
  | 'rounded-lg'
  | 'rounded-xl'
  | 'rounded-2xl'
  | 'rounded-full';
export type PortalServiceThemeDtoGradientDirection = 'bg-gradient-to-r' | 'bg-gradient-to-b';
export type PortalServiceThemeDtoShadowSize = 'none' | 'shadow' | 'sm' | 'md' | 'lg' | 'xl';
export type PortalServiceThemeDtoBreadcrumbsPosition = 'inside_content' | 'outside_content';

export type PortalServiceThemeDtoBorderColors = {
  [key in PortalServiceThemeDtoBorderType]: PortalServiceThemeDtoBorderColor;
};

export type PortalServiceThemeDtoShadowColors = {
  [key in PortalServiceThemeDtoShadowType]: [PortalServiceThemeDtoPaletteShadow];
};

export type PortalServiceThemeDtoFillColorOrGradient = [
  PortalServiceThemeDtoPaletteBg,
  PortalServiceThemeDtoPaletteBg?,
  (PortalServiceThemeDtoPaletteBg | PortalServiceThemeDtoGradientDirection)?,
  PortalServiceThemeDtoGradientDirection?
];

export type PortalServiceThemeDtoTextColor = [PortalServiceThemeDtoPaletteText];

export type PortalServiceThemeDtoBorderColor = [PortalServiceThemeDtoPaletteBorder];

export type PortalServiceThemeDtoBgColors = {
  [key in PortalServiceThemeDtoBgType]: PortalServiceThemeDtoFillColorOrGradient;
};

export type PortalServiceThemeDtoTextColors = {
  [key in PortalServiceThemeDtoTextType]: PortalServiceThemeDtoTextColor;
};

export interface PortalServiceThemeDtoThemeColors
  extends PortalServiceThemeDtoBgColors,
    PortalServiceThemeDtoTextColors,
    PortalServiceThemeDtoShadowColors,
    PortalServiceThemeDtoBorderColors {
  key: string;
  editorColor: 'light' | 'dark';
  name: string;
  logo: string;
  icon: string;
  image?: string;
}

export type PortalServiceThemeDtoThemeColorSchemas = {
  schema: PortalServiceThemeDtoColorSchemas;
  colors: PortalServiceThemeDtoThemeColors;
}[];

export interface PortalServiceThemeDtoHeader {
  type: PortalServiceThemeDtoHeaderType;
  width: PortalServiceThemeDtoHeaderWidth;
  sticky: boolean;
  className: string[];
  search: object;
  menu: object;
  logo: object;
}

export interface PortalServiceThemeDtoHero {
  type: PortalServiceThemeDtoHeroType;
  className: string[];
}

export interface PortalServiceThemeDtoFooter {
  type: PortalServiceThemeDtoFooterType;
  width: PortalServiceThemeDtoFooterWidth;
  sticky: boolean;
}

export interface PortalServiceThemeDtoSearch {
  position: PortalServiceThemeDtoSearchPosition;
}

export interface PortalServiceThemeDtoSidebar {
  show: boolean;
  homePage: boolean;
  deepPage: boolean;
  type: PortalServiceThemeDtoSidebarType;
}

export interface PortalServiceThemeDtoSecondBar {
  show: boolean;
  homePage: boolean;
  deepPage: boolean;
}

export interface PortalServiceThemeDtoBreadcrumbs {
  show: boolean;
  homePage: boolean;
  position: PortalServiceThemeDtoBreadcrumbsPosition;
}

export interface PortalServiceThemeDto {
  hero: PortalServiceThemeDtoHero;
  header: PortalServiceThemeDtoHeader;
  footer: PortalServiceThemeDtoFooter;
  search: PortalServiceThemeDtoSearch;
  sidebar: PortalServiceThemeDtoSidebar;
  secondbar: PortalServiceThemeDtoSecondBar;
  breadcrumbs: PortalServiceThemeDtoBreadcrumbs;
  style: {
    radius: { className: string[] };
    border: { className: string[] };
    shadow: { className: string[] };
  };
  colors: {
    light: PortalServiceThemeDtoThemeColors;
    dark: PortalServiceThemeDtoThemeColors;
  };
  content: {
    cols: {
      [key in 'base' | 'md' | 'lg']: number;
    };
    gap: {
      [key in 'base' | 'md' | 'lg']: number;
    };
  };
}

/**
 * Change events
 */
export type PortalServiceBlockIndexPayloadDto = Pick<PortalServiceBlockDto, 'id' | 'index' | 'place'>;
export type PortalServiceBlockPlacePayloadDto = Pick<PortalServiceBlockDto, 'id' | 'place' | 'index'>;
export type PortalServiceBlockSizePayloadDto = Pick<PortalServiceBlockDto, 'id' | 'colspan' | 'rowspan' | 'mediaSizes'>;
export type PortalServiceBlockUpdatePayloadDto<Dto extends PortalServiceBlockDto = PortalServiceBlockDto> = Omit<
  Dto,
  'type' | 'place' | 'index' | 'colspan' | 'rowspan' | 'actions' | 'mediaSizes'
>;

export type PortalServiceBlockUpdateActionsPayloadDto<Dto extends PortalServiceBlockDto = PortalServiceBlockDto> = Pick<
  Dto,
  'id' | 'actions'
>;

export type PortalServiceMenuItemUpdatePayloadDtoNoLink<
  DtoAll extends PortalServiceMenuItemDto = PortalServiceMenuItemDto,
  DtoLink extends PortalServiceLinkMenuItemDto = PortalServiceLinkMenuItemDto
> = Omit<
  Exclude<DtoAll, DtoLink>,
  'type' | 'positionType' | 'parentId' | 'index' | 'hasChildren' | 'children' | 'visible' | 'url' | 'slug'
>;

export type PortalServiceLinkMenuItemUpdatePayloadDto<
  DtoLink extends PortalServiceLinkMenuItemDto = PortalServiceLinkMenuItemDto
> = Omit<DtoLink, 'type' | 'positionType' | 'parentId' | 'index' | 'hasChildren' | 'children' | 'visible' | 'slug'>;

export type PortalServiceMenuItemUpdatePayloadDto =
  | PortalServiceMenuItemUpdatePayloadDtoNoLink
  | PortalServiceLinkMenuItemUpdatePayloadDto;

export type PortalServiceMenuItemSlugUpdatePayloadDto<Dto extends PortalServiceMenuItemDto = PortalServiceMenuItemDto> =
  Pick<Dto, 'id' | 'slug'>;
export type PortalServiceMenuItemMovePayloadDto = Pick<
  PortalServiceMenuItemDto,
  'id' | 'positionType' | 'parentId' | 'index'
>;
export type PortalServiceMenuItemChangeVisibilityPayloadDto<
  Dto extends PortalServiceMenuItemDto = PortalServiceMenuItemDto
> = Pick<Dto, 'id' | 'visible'>;

export interface PortalServiceAddPagePayloadDto {
  id: string;
  path: string;
  title?: string;
  visible: boolean;
}
export type PortalServiceUpdatePagePayloadDto = Omit<PortalServiceAddPagePayloadDto, 'visible'>;
export type PortalServiceChangePageVisibilityPayloadDto = Pick<PortalServiceAddPagePayloadDto, 'id' | 'visible'>;
export type PortalServiceUpdateMetaSettingsPayloadDto = Pick<PortalServiceSettingsDto, 'name' | 'description'>;
export type PortalServiceUpdateAccessSettingsPayloadDto = Pick<PortalServiceSettingsDto, 'access'>;
export type PortalServiceUpdateSearchAnalyticsSettingsPayloadDto = Pick<
  PortalServiceSettingsDto,
  'searchAnalyticsEnabled'
>;
export type PortalServiceUpdatePortalAnalyticsSettingsPayloadDto = Pick<
  PortalServiceSettingsDto,
  'portalAnalyticsEnabled'
>;
export type PortalServiceUpdateSearchIndexSettingsPayloadDto = Pick<PortalServiceSettingsDto, 'searchIndexEnabled'>;
export type PortalServiceUpdateCustomCodeSettingsPayloadDto = Pick<
  PortalServiceSettingsDto,
  'customCode' | 'customStyle' | 'customScript'
>;
export type PortalServiceUpdateThemeSettingsPayloadDto = DeepPartial<PortalServiceThemeDto>;
export type PortalServiceUpdateBrandingSettingPayloadDto = Pick<PortalServiceSettingsDto, 'disableBranding'>;
export type PortalServiceUpdateHeroSettingPayloadDto = Pick<
  PortalServiceSettingsDto,
  'searchEnabled' | 'greetingEnabled' | 'greetingMessage' | 'headerBlocksEnabled'
>;

export type ChangeEventPortalServiceType =
  | 'addBlock'
  | 'updateBlock'
  | 'updateBlockActions'
  | 'deleteBlock'
  | 'updateBlockIndex'
  | 'updateBlockPlace'
  | 'updateBlockSize'
  | 'addMenuItem'
  | 'updateMenuItem'
  | 'updateMenuItemSlug'
  | 'changeMenuItemVisibility'
  | 'deleteMenuItem'
  | 'moveMenuItem'
  | 'addPage'
  | 'updatePage'
  | 'deletePage'
  | 'changePageVisibility'
  | 'updateMetaSettings'
  | 'updateAccessSettings'
  | 'updateSearchAnalyticsSettings'
  | 'updatePortalAnalyticsSettings'
  | 'updateSearchIndexSettings'
  | 'updateCustomCodeSettings'
  | 'updateThemeSettings'
  | 'updateBrandingSetting'
  | 'updateHeroSetting';

export interface PortalServiceEventDtoMeta {
  userId: number;
  pageId: string;
}

export interface PortalServiceChangeEventDtoBase<NewValue = undefined, OldValue = NewValue> {
  type: ChangeEventPortalServiceType;
  newValue: NewValue;
  oldValue: OldValue;
  groupId?: string;
  batchId?: string;
  squashId?: string;
  collectId?: string;
  meta: PortalServiceEventDtoMeta;
}

export interface PortalServiceAddBlockEventDto
  extends PortalServiceChangeEventDtoBase<
    | Exclude<PortalServiceBlockDto, PortalServiceNoteBlockDto | PortalServiceContentBlockDto>
    | Omit<PortalServiceNoteBlockDto, 'shareId' | 'shareSecurityKey'>
    | Omit<PortalServiceContentBlockDto, 'shareId' | 'shareSecurityKey' | 'text'>,
    undefined
  > {
  type: 'addBlock';
}

export interface PortalServiceUpdateBlockEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceBlockUpdatePayloadDto> {
  type: 'updateBlock';
}

export interface PortalServiceUpdateBlockActionsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceBlockUpdateActionsPayloadDto> {
  type: 'updateBlockActions';
}

export interface PortalServiceDeleteBlockEventDto
  extends PortalServiceChangeEventDtoBase<undefined, PortalServiceBlockDto> {
  type: 'deleteBlock';
}

export interface PortalServiceUpdateBlockIndexEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceBlockIndexPayloadDto> {
  type: 'updateBlockIndex';
}

export interface PortalServiceUpdateBlockPlaceEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceBlockPlacePayloadDto> {
  type: 'updateBlockPlace';
}

export interface PortalServiceUpdateBlockSizeEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceBlockSizePayloadDto> {
  type: 'updateBlockSize';
}

export interface PortalServiceAddMenuItemEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceMenuItemDto, undefined> {
  type: 'addMenuItem';
}

export interface PortalServiceUpdateMenuItemEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceMenuItemUpdatePayloadDto> {
  type: 'updateMenuItem';
}

export interface PortalServiceUpdateMenuItemSlugEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceMenuItemSlugUpdatePayloadDto> {
  type: 'updateMenuItemSlug';
}

export interface PortalServiceDeleteMenuItemEventDto
  extends PortalServiceChangeEventDtoBase<undefined, PortalServiceMenuItemDto> {
  type: 'deleteMenuItem';
}

export interface PortalServiceChangeMenuItemVisibilityEventDto
  extends PortalServiceChangeEventDtoBase<
    PortalServiceMenuItemChangeVisibilityPayloadDto,
    PortalServiceMenuItemChangeVisibilityPayloadDto
  > {
  type: 'changeMenuItemVisibility';
}

export interface PortalServiceMoveMenuItemEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceMenuItemMovePayloadDto> {
  type: 'moveMenuItem';
}

export interface PortalServiceAddPageEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceAddPagePayloadDto, undefined> {
  type: 'addPage';
}

export interface PortalServiceUpdatePageEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdatePagePayloadDto> {
  type: 'updatePage';
}

export interface PortalServiceDeletePageEventDto
  extends PortalServiceChangeEventDtoBase<undefined, PortalServiceAddPagePayloadDto> {
  type: 'deletePage';
}

export interface PortalServiceChangePageVisibilityEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceChangePageVisibilityPayloadDto> {
  type: 'changePageVisibility';
}

export interface PortalServiceUpdateMetaSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateMetaSettingsPayloadDto> {
  type: 'updateMetaSettings';
}

export interface PortalServiceUpdateAccessSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateAccessSettingsPayloadDto> {
  type: 'updateAccessSettings';
}

export interface PortalServiceUpdateSearchAnalyticsSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateSearchAnalyticsSettingsPayloadDto> {
  type: 'updateSearchAnalyticsSettings';
}

export interface PortalServiceUpdatePortalAnalyticsSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdatePortalAnalyticsSettingsPayloadDto> {
  type: 'updatePortalAnalyticsSettings';
}

export interface PortalServiceUpdateSearchIndexSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateSearchIndexSettingsPayloadDto> {
  type: 'updateSearchIndexSettings';
}

export interface PortalServiceUpdateCustomCodeSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateCustomCodeSettingsPayloadDto> {
  type: 'updateCustomCodeSettings';
}

export interface PortalServiceUpdateThemeSettingsEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateThemeSettingsPayloadDto> {
  type: 'updateThemeSettings';
}

export interface PortalServiceUpdateBrandingSettingEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateBrandingSettingPayloadDto> {
  type: 'updateBrandingSetting';
}

export interface PortalServiceUpdateHeroSettingEventDto
  extends PortalServiceChangeEventDtoBase<PortalServiceUpdateHeroSettingPayloadDto> {
  type: 'updateHeroSetting';
}

export type PortalServiceChangeEventDto =
  | PortalServiceAddBlockEventDto
  | PortalServiceUpdateBlockEventDto
  | PortalServiceUpdateBlockActionsEventDto
  | PortalServiceDeleteBlockEventDto
  | PortalServiceUpdateBlockIndexEventDto
  | PortalServiceUpdateBlockPlaceEventDto
  | PortalServiceUpdateBlockSizeEventDto
  | PortalServiceAddMenuItemEventDto
  | PortalServiceDeleteMenuItemEventDto
  | PortalServiceChangeMenuItemVisibilityEventDto
  | PortalServiceUpdateMenuItemEventDto
  | PortalServiceUpdateMenuItemSlugEventDto
  | PortalServiceMoveMenuItemEventDto
  | PortalServiceAddPageEventDto
  | PortalServiceDeletePageEventDto
  | PortalServiceUpdatePageEventDto
  | PortalServiceChangePageVisibilityEventDto
  | PortalServiceUpdateMetaSettingsEventDto
  | PortalServiceUpdateAccessSettingsEventDto
  | PortalServiceUpdateSearchAnalyticsSettingsEventDto
  | PortalServiceUpdatePortalAnalyticsSettingsEventDto
  | PortalServiceUpdateSearchIndexSettingsEventDto
  | PortalServiceUpdateCustomCodeSettingsEventDto
  | PortalServiceUpdateThemeSettingsEventDto
  | PortalServiceUpdateBrandingSettingEventDto
  | PortalServiceUpdateHeroSettingEventDto;

/**
 * Content
 */
export interface PortalServiceSettingsAccessConsoleDto {
  owner: boolean;
  managers: boolean;
  members: boolean;
  guests: boolean;
}

export interface PortalServiceSettingsAccessPortalDto {
  owner: boolean;
  managers: boolean;
  members: boolean;
  guests: boolean;
  anyone: boolean;
  clients: boolean;
  skipClientValidation: boolean;
  requireClientEmail: boolean;
}

export interface PortalServiceSettingsAccessDto {
  console: PortalServiceSettingsAccessConsoleDto;
  portal: PortalServiceSettingsAccessPortalDto;
}

export interface PortalAIAssistantSettingsDTO {
  availability: {
    loggedIn: boolean;
    anyone: boolean;
  };
}

export interface PortalServiceSettingsDto {
  portalId: string;
  version: number;
  name: string;
  description: string;
  domain: string;
  orgId: string;
  workspaceId: string;
  language: string;
  searchEnabled: boolean;
  greetingEnabled: boolean;
  headerBlocksEnabled: boolean;
  greetingMessage: string;
  aiAssistantSettings: PortalAIAssistantSettingsDTO;
  access: PortalServiceSettingsAccessDto;
  requestAccessPage?: {
    title: string | null;
    description: string | null;
  };
  clientSettings?: {
    createTasks: boolean;
    editTasks: boolean;
    commentTasks: boolean;
    changeTasksStatus: boolean;
    showComments: boolean;
  };
  searchAnalyticsEnabled: boolean;
  portalAnalyticsEnabled: boolean;
  searchIndexEnabled: boolean;
  customCode?: string;
  customScript?: string;
  customStyle?: string;
  disableBranding?: boolean;
  paymentAccess?: PortalPaymentAccessServices[];
}

export interface PortalServicePageDto {
  id: string;
  title?: string;
  path: string;
  blocks: PortalServiceBlockDto[];
  visible: boolean;
  permissions?: PortalServicePermissionsDto;
  isOrigin?: boolean | null;
  originGlobalId?: string | null;
}

export interface PortalServiceContentDto {
  theme: DeepPartial<PortalServiceThemeDto>;
  settings: PortalServiceSettingsDto;
  topMenu: PortalServiceMenuItemDto[];
  sidebarMenu: PortalServiceMenuItemDto[];
  footerMenu: PortalServiceMenuItemDto[];
  page?: PortalServicePageDto;
}
